import api from '../../services/api';
import {utilsCreateTemporaryLinkToDownload} from "@/utils";

export default {
  state: {
    initiatorsFiles: [],
    uploadedFiles: [],
    reportFiles: [],
    incomingFiles: [],
    logsIncomingFiles: []
  },
  getters: {
    getUploadedFiles(state) {
      return state.uploadedFiles
    },
  },
  mutations: {
    setUploadedFiles(state, payload) {
      state.uploadedFiles = payload
    },
    setReportFiles(state, payload) {
      state.reportFiles = payload
    },
    setIncomingFiles(state, payload) {
      state.incomingFiles = payload
    },
    setLogsIncomingFiles(state, payload) {
      state.logsIncomingFiles = payload
    }
  },
  actions: {
    apiGetProgramFiles({commit},payload) {
      return new Promise((resolve, reject) => {
        if(payload.page){
          payload.page = payload.page - 1
        }
        api.get('program_files', { params: payload }).then((data) => {
          const response = data.data.length > 0 ? [...data.data] : null
          if(payload.prefix == 'uploaded-files'){
            commit('setUploadedFiles', data.data)
          } else {
            commit('setReportFiles', data.data)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    apiGetDownloadFile({commit},payload) {
      return new Promise((resolve, reject) => {
        api.get(`incoming_files/${payload.uuid}`,
          { responseType: 'blob' }).then(data => {
          utilsCreateTemporaryLinkToDownload(payload.fileName, data.data,'application/zip','zip')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    async apiGetIncomingFiles({ commit }, payload) {
      const data = await api.get(`/incoming_files`, { params: payload })
      commit('setIncomingFiles', data.data)
      return data
    },
    async apiCancelFile({commit}, payload) {
      const { uuid, reason } = payload
      await api.post(`incoming_files/${uuid}/cancel`, {
        reason: reason
      })
    },
    async apiReprocessFile({commit}, payload) {
      const { uuid, reason } = payload
      await api.post(`incoming_files/${uuid}/reprocess`, {
        reason: reason
      })
    },
    async apiGetLogsIncomingFiles({ commit }, payload) {
      const data = await api.get(`/rules/logs/IncomingFileReprocess?`, { params: payload })
      commit('setLogsIncomingFiles', data.data)
      return data
    },
  }
}
